module.exports = __webpack_public_path__ + "img/style.da54af1f.png";